<template>
  <div>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="8">
          <h1 class="headline font-weight-light">
            <router-link class="link-a" to="/Inventory/Same-Item"
              >SAME ITEM</router-link
            >
            / Print
          </h1>
        </v-col>
        <v-col cols="4" class="text-right">
          <v-btn rounded small @click="print()">
            <v-icon class="mr-1" dark small>mdi-printer</v-icon>
            Print</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <div id="printDiv">
      <v-row>
        <v-col cols="4">
          <img
            src="../../assets/bardode/acacia2.png"
            style="width: 30% !important;"
          />
        </v-col>
        <v-col cols="4" class="text-center">
          <b>SAMEITEM</b>
        </v-col>
        <v-col cols="4" class="text-right">
          <b>ShipDate : {{ data_main.log_date }}</b>
        </v-col>
      </v-row>
      <v-row style="margin-top:10px;">
        <v-col cols="6" style="font-size:20px;"
          ><b>ส่งจาก : INVENTORY</b></v-col
        >
        <v-col cols="6" style="font-size:20px;"
          ><b>ส่งถึง : {{ data_main.supplier_name }}</b></v-col
        >
      </v-row>
      <v-row style="margin-top:20px;">
        <v-col cols="12">
          <table border="1" width="100%">
            <thead>
              <tr
                class="text-center"
                style="background-color: rgb(221, 221, 221);"
              >
                <th>Item</th>
                <th>Case No</th>
                <th>Model</th>
                <th>SerialPart</th>
                <th>อาการเสีย</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center">
                <td>1.</td>
                <td>{{ data_main.case_id }}</td>
                <td>{{ data_main.model }}</td>
                <td>{{ data_main.serial }}</td>
                <td>{{ data_main.symptom }}</td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>
      <v-row style="margin-top:20px;">
        <v-col cols="2" class="text-right">
          <b>ผู้ส่งของ </b>
        </v-col>
        <v-col cols="3">{{ data_main.log_name }}</v-col>
        <v-col cols="3" class="text-right">ผู้รับของ</v-col>
        <v-col cols="3" style="border-bottom: 1px solid #000;"></v-col>
      </v-row>
      <v-row style="margin-top:10px;">
        <v-col cols="2" class="text-right">
          <b>วันที่ส่งของ </b>
        </v-col>
        <v-col cols="3">{{ data_main.log_datetime }}</v-col>
        <v-col cols="3" class="text-right">วันที่รับของ</v-col>
        <v-col cols="3" style="border-bottom: 1px solid #000;"></v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";

const url = `${process.env.VUE_APP_ROOT_API}/api/`;
export default {
  mounted() {
    this.sameitem_id = this.$route.params.sameitem_id;
    this.get_data();
  },
  methods: {
    async get_data() {
      await axios
        .get(url + "same-item/" + this.sameitem_id)
        .then((response) => {
          this.data_main = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    print() {
      this.$htmlToPaper("printDiv");
    },
  },
  data() {
    return {
      data_main: [],
      sameitem_id: "",
    };
  },
};
</script>
